import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

/**
 * ErrorBoundary that forgets a caught error as soon as the route changes.
 *
 * The root boundary in main.tsx sits above the router, so once a page threw
 * during render the whole app stayed on the error screen even after the user
 * pressed Back. Keying the boundary by pathname remounts it on navigation, so
 * leaving the broken page shows the next page normally.
 */
const RouteErrorBoundary = ({ children }: { children: ReactNode }) => {
	const { pathname } = useLocation();
	return <ErrorBoundary key={pathname}>{children}</ErrorBoundary>;
};

export default RouteErrorBoundary;
